import React from 'react';
import Logo from './Upload/Logo';
import LogoView from './Upload/LogoView';
import ContactInfoForm from './Upload/Contact';
import { useScreenSize } from '../../hooks/useScreenSize';

const SettingsManager: React.FC = () => {
  const { isMobile } = useScreenSize();
  return (
    <div className="flex-column gap-2 w-100">
      <div className="flex-row-align space-between pb-2">
        <h3>Settings</h3>
      </div>
      <div>
        <h4>Voeg een logo toe:</h4>
        <p className="s-p italic">! Bestandnaam moet logo en logo-small noemen.</p>
      </div>
      <div className="grid reverse-on-mobile">
        <div className="flex-row-align colomn-6 colomn-small-12">
          <LogoView />
        </div>
        <div
          className={`flex-row-align ${isMobile ? 'justify-start pt-1' : 'justify-center'} colomn-6 colomn-small-12`}
        >
          <Logo />
        </div>
      </div>
      <div className="pb-2">
        <h4>Voeg contact gegevens toe:</h4>
      </div>
      <ContactInfoForm />
    </div>
  );
};

export default SettingsManager;
